import { ErrorView } from "components/ErrorView/ErrorView";
import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject, Navigate } from "react-router-dom";
const ProjectListPage = React.lazy(() => import("modules/MainModule/pages/ProjectListPage/ProjectListPage"));
const ProjectEditPage = React.lazy(() => import("modules/MainModule/pages/ProjectEditPage/ProjectEditPage"));
const ProjectSurveysPage = React.lazy(
  () => import("modules/MainModule/pages/ProjectSurveysProgressPage/ProjectSurveysProgressPage"),
);

const HomeRedirectPage = React.lazy(
  () => import("modules/MainModule/pages/HomeRedirectPage/HomeRedirectPage"),
);
const CreatePage = React.lazy(() => import("modules/MainModule/pages/CreatePage/CreatePage"));
const CreateGroupPage = React.lazy(() => import("modules/MainModule/pages/CreateGroupPage/CreateGroupPage"));
const MainModule = React.lazy(() => import("./MainModule"));

export const MainModuleRoutes: RouteObject = {
  path: ":clientId/",
  element: <ModuleRoute El={MainModule} moduleName="main" />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "",
      element: <PageRoute El={HomeRedirectPage} />,
    },
    {
      path: "home",
      element: <PageRoute El={ProjectListPage} />,
    },
    {
      path: "create",
      element: <PageRoute El={CreatePage} inPolicies={["TeamUser"]} />,
    },
    {
      path: "result/:projectId/:tab?/:questionId?",
      element: (
        <Navigate
          to={`${window.location.pathname.replace("/result/", "/results/")}${window.location.search}`}
        />
      ),
    },
    {
      path: "project/:projectId",
      element: (
        <Navigate
          to={`${window.location.pathname.replace("/project/", "/projects/")}${window.location.search}`}
        />
      ),
    },
    {
      path: "projects/:projectId/:tab?",
      element: <PageRoute El={ProjectEditPage} inPolicies={["TeamUser", "IdeallyAdminViewer"]} />,
    },
    {
      path: "project-surveys/:projectId",
      element: <PageRoute El={ProjectSurveysPage} inPolicies={["TeamUser", "IdeallyAdminViewer"]} />,
    },
    {
      path: "create-group",
      element: <PageRoute El={CreateGroupPage} inPolicies={["IdeallyAdmin", "IdeallyAdminViewer"]} />,
    },
    {
      path: "edit-group/:projectGroupId",
      element: <PageRoute El={CreateGroupPage} inPolicies={["IdeallyAdmin", "IdeallyAdminViewer"]} />,
    },
  ],
};
